import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import * as firebaseSelectors from '../../../Core/Firebase/firebase.selectors'
import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as loaderActions from '../../../Core/Loader/loader.actions'

class SessionCounter extends React.Component {
  constructor(props) {
    super(props)
    const dateTime =
      typeof props.dateTime == 'string' ? new Date(props.dateTime).getTime() : props.dateTime
    this.state = {
      time: 0,
      date: dateTime,
    }
    this.setDateInterval()
  }
  componentWillUnmount() {
    clearInterval(this.timer)
  }

  setDateInterval() {
    const { addLoader } = this.props
    this.timer = setInterval(() => {
      const time = this.state.date - Date.now()
      if (time < 0 && process.env.TIMER_ZERO_BLOCKS) {
        console.log('>>>ATENTION:>>> Check endSessionDate. Timer goes below 0')
        addLoader('changing_session_loader')
      }
      this.setState({ time: time })
    }, 100)
  }

  UNSAFE_componentWillReceiveProps(props) {
    const dateTime =
      typeof props.dateTime == 'string' ? new Date(props.dateTime).getTime() : props.dateTime
    this.setState({
      time: 0,
      date: dateTime,
    })
  }

  textTime(number) {
    return number < 10 ? '0' + number : number
  }

  render() {
    const { time } = this.state
    const { relativeTurn, groupData } = this.props

    const totalSeconds = Math.abs(Math.floor(time / 1000))
    const minutes = Math.floor(totalSeconds / 60) % 60
    const hours = Math.floor(totalSeconds / 3600)
    const seconds = totalSeconds % 60
    let lastTime =
      totalSeconds && totalSeconds < 300 ? 'counter--block last--time' : 'counter--block'
    if (time <= 0) {
      return null
    }
    return (
      <div className="counter--position">
        <div className="counter--border">
          <div className="counter">
            <div className="counter--turn">
              <span>
                <FormattedMessage id="indicators.session" />
              </span>
              <span>{groupData.session}</span>
            </div>
            <div className={lastTime}>
              <span className="counter--title">
                <FormattedMessage id="ui.nextSession" />
              </span>
              <div className="counter--item">
                {this.textTime(hours) +
                  ' : ' +
                  this.textTime(minutes) +
                  ' : ' +
                  this.textTime(seconds)}
              </div>
            </div>
            <div className="counter--turn">
              <span>
                <FormattedMessage id="indicators.turn" />
              </span>
              <span>
                {relativeTurn}/{groupData.maxTurns}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SessionCounter.propTypes = {
  dateTime: PropTypes.string,
  relativeTurn: PropTypes.number,
  groupData: PropTypes.object,
  addLoader: PropTypes.func,
}

const mapStateToProps = (state) => ({
  relativeTurn: indicatorsSelectors.getRelativeTurn(state),
  dateTime: firebaseSelectors.getEndSessionTime(state),
  groupData: firebaseSelectors.getGroupData(state),
})
const mapDispatchToProps = (dispatch) => {
  return {
    addLoader: bindActionCreators(loaderActions.addLoader, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SessionCounter))
